module.exports = __webpack_public_path__ + "img/icon_notice.7cf498cb.png";